import { Library } from './ui-interfaces'
import { LibraryCommonUIProps } from './libraries-interfaces'

export type DrilldownLibrary = Omit<LibraryCommonUIProps, 'usage'> &
  Pick<
    Library,
    | 'applications'
    | 'servers'
    | 'usage'
    | 'libraryClassUsageCounts'
    | 'grade'
    | 'mergedApplications'
    | 'vulnerabilities'
    | 'custom'
    | 'privateLibrary'
    | 'severity'
  >

export enum LibraryGridPanelID {
  Usage = 'usage',
  Overview = 'overview'
}
